import React from "react";

const GraduationCapIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M12 2 1 7.5 12 13l9-4.64V15h2V7.5L12 2Zm-7 8.09V15c0 2.21 3.13 4 7 4s7-1.79 7-4v-4.91l-7 3.64-7-3.64Z" />
  </svg>
);

export default GraduationCapIcon;
